import {
  Outlet,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { styled } from '@material-ui/styles';
import DashboardNavbar from '../DashboardNavbar';
import DashboardSidebar from '../DashboardSidebar';
import Alerts from '../Alerts';

const SIDEBAR_WIDTH = 256;
const SIDEBAR_COLLAPSED_WIDTH = 72;

const DashboardLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  }),
);

// We avoid `styled('div', { shouldForwardProp })` here because
// @material-ui/styles doesn't honour shouldForwardProp — the custom prop
// leaks to the DOM and spams React warnings. Instead, switch by className.
const DashboardLayoutWrapper = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: SIDEBAR_WIDTH,
      transition: theme.transitions.create('padding-left', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.standard,
      }),
      '&.sidebar-collapsed': {
        paddingLeft: SIDEBAR_COLLAPSED_WIDTH,
      },
    },
  }),
);

const DashboardLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
});

const DashboardLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
});

const DashboardLayoutComponent = ({
  items,
  alerts,
  isDrawerOpen,
  onDrawerToggle,
  isCollapsed,
  onCollapseToggle,
  name,
  roleName,
}) => (
  <DashboardLayoutRoot>
    <DashboardNavbar
      onDrawerToggle={onDrawerToggle}
      name={name}
      roleName={roleName}
    />
    <DashboardSidebar
      items={items}
      isDrawerOpen={isDrawerOpen}
      onDrawerToggle={onDrawerToggle}
      isCollapsed={isCollapsed}
      onCollapseToggle={onCollapseToggle}
    />
    <DashboardLayoutWrapper className={isCollapsed ? 'sidebar-collapsed' : ''}>
      <DashboardLayoutContainer>
        <DashboardLayoutContent>
          <Outlet />
        </DashboardLayoutContent>
      </DashboardLayoutContainer>
    </DashboardLayoutWrapper>
    <Alerts
      alerts={alerts}
    />
  </DashboardLayoutRoot>
);

DashboardLayoutComponent.propTypes = {
  items: PropTypes.array.isRequired,
  alerts: PropTypes.array.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
  onDrawerToggle: PropTypes.func.isRequired,
  isCollapsed: PropTypes.bool,
  onCollapseToggle: PropTypes.func,
};

export default DashboardLayoutComponent;
